import Header  from '../../Plantilla/Header'; // Importa el componente Header
import Footer from '../../Plantilla/Footer'; // Importa el componente Footer
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import api from '../configuracion/config';
import { InsertarUsuario } from '../modales/modalInsertarUsuarios';
import ActualizarUsuario from '../modales/modalActualizarUsuarios';
import ResponsivePagination from './ResponsivePagination';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/default.css';
import { estiloAlertify} from '../Funciones'
import { authStorage } from '../../utils/storage';

import {
  faPlus,
  faFilter,
  faBroom,
  faMagnifyingGlass,
  faXmark,
  faFilePen,
  faFaceFrown,
  faTrashCan,
} from '@fortawesome/free-solid-svg-icons';
import './Usuarios.css';

function TablaUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState('');
  const [tipoFiltro, setTipoFiltro] = useState('todos');
  const [estadoFiltro, setEstadoFiltro] = useState('todos');
  const [mostrarModalInsertar, setMostrarModalInsertar] = useState(false);
  const [mostrarModalActualizar, setMostrarModal] = useState(false);
  const [drwUsuario, setDrwUsuario] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [isMobileView, setIsMobileView] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 576 : false
  );
  const userTipo = authStorage.getUserType();
  const tiposUsuario = {
    user: 'Usuario',
    supervisor: 'Supervisor',
    admin: 'Administrador',
  };


  const load = async () => {
    try {
      
      const response = await api.get('/usuarios');

      if (response.status === 200) {
        setUsuarios(response.data);
      }
    } catch (error) {
      console.error('Error al obtener los Usuarios:', error);
    }
  };

  useEffect(() => {
        load();          
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(max-width: 575.98px)');
    const handleChange = (event) => {
      setIsMobileView(event.matches);
    };

    setIsMobileView(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  const handlePageClick = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setPageNumber(0);
  };

  const handleInputChange = (event) => {
    setSearchInput(event.target.value);
    setPageNumber(0);
  };

  const limpiarFiltros = () => {
    setSearchInput('');
    setTipoFiltro('todos');
    setEstadoFiltro('todos');
    setPageNumber(0);
  };

  const funcionMostrarModalInsertar = () => {
    setMostrarModalInsertar(true);
  };

  const funcionCerrarModalInsertar = () => {
    setMostrarModalInsertar(false);
  };

  const funcionGuardarUsuario = async (formulario) => {
      const { strUsuario, strNombres, strPassword, strTipo, bolActivo } =  formulario;
      const dttUsuario = {
        strUsuario,
        strNombres,
        strPassword,
        strTipo,
        bolActivo,
      };

      try {

        const buscarUsuario = await api.get(`/usuarios`);
        const usuarioExistente = buscarUsuario.data.find((usuario) => usuario.strUsuario === strUsuario);

         if (usuarioExistente) {
          alertify.warning(`El usuario ${usuarioExistente.strUsuario} ya se encuentra registrado como:  ${usuarioExistente.strNombres}`);
           estiloAlertify(3);
           return;
         } 
         else 
         {                    
            const response = await api.post('/InsertarUsuario', dttUsuario);
            if (response.status === 200) {
                load();
                alertify.success('Guardado.');
                estiloAlertify(1);
            }
           
         }
      } catch (error) {
        console.error('Error al obtener el usuario:', error);
      }
      funcionCerrarModalInsertar();
    
  };

  const funcionEliminarUsuario = async (strUsuario) => {
    alertify
      .confirm('¿Está seguro que desea eliminar este Usuario?', async (e) => {
        if (e) {
          try {
            // Realiza la llamada a la API para eliminar el usuario
            const response = await api.delete(`/EliminarUsuario/${strUsuario}`);
  
            // Verifica si la respuesta del servidor fue exitosa
            if (response.status === 200) {             
              // Si el usuario fue eliminado correctamente
              if (response.data === 'Eliminado') {
                setUsuarios(usuarios.filter((item) => item.strUsuario !== strUsuario));
                load();
                alertify.success('Usuario eliminado correctamente.');
                estiloAlertify(1);
              } 
              // Si el usuario está asociado a anotaciones
              else if (response.data === 'Asociada') {
                alertify.warning('No puede eliminar el usuario, está siendo utilizado en las Minutas.');
                estiloAlertify(3);
              }
            }
          } catch (error) {
            // Manejo de errores de la API
            if (error.response) {
              alertify.warning("No puede eliminar el usuario, tiene Minutas Asociadas");
              estiloAlertify(3);
            } else if (error.request) {
              // La solicitud fue hecha pero no se recibió respuesta
              console.error('Error en la solicitud:', error.request);
              alertify.error('No se recibió respuesta del servidor.');
            } else {
              // Algo sucedió al configurar la solicitud
              console.error('Error', error.message);
              alertify.error(`Error al eliminar el usuario: ${error.message}`);
            }
            estiloAlertify(0);
          }
        }
      })
      .set({
        labels: {
          ok: 'SI', // Etiqueta del botón OK
          cancel: 'NO', // Etiqueta del botón Cancelar
        },
        title: 'AVISO', // Título personalizado
      });
  };
  




  const funcionMostrarModalActualizar = (usuario) => {
    setDrwUsuario({
      ...usuario,
    });

    setMostrarModal(true);
  };

  const funcionCerrarModalActualizar = () => {
    setMostrarModal(false);
  };

  const funcionActualizarUsuario = async (usuarioActualizar) => {
    if (usuarioActualizar.strUsuario) {
      try 
      {         
          const response = await api.put(`/ActualizarUsuario/${usuarioActualizar.strUsuario}`,usuarioActualizar);
         if (response.status === 200) {
            load();
            alertify.success('Guardado.');
            estiloAlertify(1);
            funcionCerrarModalActualizar();
         }         
      
      } catch (error) {
        console.error('Error al actualizar la anotación:', error);
      }
    }
  };


  const funcionActualizarPassword = async (usuarioActualizar) => {   
  
    try {
          const { strPassword } = usuarioActualizar;  
          const data = {strUsuario: drwUsuario.strUsuario, strPassword: strPassword };

          const response = await api.put(`/ActualizaPassword`,data);  
          if (response.status === 200) {
              load();
              alertify.success('Guardado.');
              estiloAlertify(1);
              funcionCerrarModalActualizar();
        }
      
    } catch (error) {
      console.error('Error al actualizar la contraseña:', error);
    }
  };
  

  // Lógica para aplicar el filtro
  const filteredData = usuarios.filter((drw) => {
    const formattedSearchInput = searchInput.toLowerCase();
    const usuarioMatch = drw.strUsuario
      .toLowerCase()
      .includes(formattedSearchInput);
    const nomnreMatch = drw.strNombres
      .toLowerCase()
      .includes(formattedSearchInput);
    const filtroTexto = usuarioMatch || nomnreMatch;
    const filtroTipo = tipoFiltro === 'todos' || drw.strTipo === tipoFiltro;
    const filtroEstado =
      estadoFiltro === 'todos' ||
      (estadoFiltro === 'activo' ? drw.bolActivo : !drw.bolActivo);

    return filtroTexto && filtroTipo && filtroEstado;
  });



  // Lógica para la paginación
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const currentPage =
    pageCount > 0 ? Math.min(pageNumber, pageCount - 1) : 0;
  const offset = currentPage * itemsPerPage;
  const paginatedData = filteredData.slice(offset, offset + itemsPerPage);
  const hayFiltrosActivos =
    searchInput !== '' || tipoFiltro !== 'todos' || estadoFiltro !== 'todos';
  const goToFirstPage = () => setPageNumber(0);
  const goToLastPage = () => setPageNumber(Math.max(pageCount - 1, 0));
  const mostrarUsuariosComoCards =
    isMobileView && (itemsPerPage === 10 || itemsPerPage === 50);
  const mostrarUsuariosDosPorFila = isMobileView && itemsPerPage === 50;

  return (
   <div className="usuarios-page" style={{ minHeight: '10vh', display: 'flex', flexDirection: 'column' }}>
      <header>
        <Header />
      </header>
      {userTipo === 'admin' ? (

     <main className="container-fluid mt-2" style={{ flex: '1', minHeight: 'calc(100vh - 20px)' }}>
        <div className="row g-3">
          <div className="col-xl-3 col-lg-4">
            <div className="card border-0 shadow-sm p-3 usuarios-filter-card">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="m-0 text-secondary">
                  <FontAwesomeIcon icon={faFilter} className="me-2" />
                  Filtros
                </h6>
                {hayFiltrosActivos && (
                  <span className="badge rounded-pill text-bg-light border">
                    Activos
                  </span>
                )}
              </div>

              <div className="form-group small">
                <label htmlFor="filtroUsuario">Usuario / nombre</label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </span>
                  <input
                    id="filtroUsuario"
                    type="text"
                    className="form-control"
                    placeholder="Ej. admin o Juan"
                    value={searchInput}
                    onChange={handleInputChange}
                  />
                  {searchInput && (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setSearchInput('')}
                      title="Limpiar texto"
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  )}
                </div>
              </div>

              <div className="form-group small mt-2">
                <label htmlFor="tipoFiltro">Tipo de usuario</label>
                <select
                  id="tipoFiltro"
                  className="form-control form-control-sm"
                  value={tipoFiltro}
                  onChange={(e) => {
                    setTipoFiltro(e.target.value);
                    setPageNumber(0);
                  }}
                >
                  <option value="todos">Todos</option>
                  <option value="admin">Administrador</option>
                  <option value="supervisor">Supervisor</option>
                  <option value="user">Usuario</option>
                </select>
              </div>

              <div className="form-group small mt-2">
                <label htmlFor="estadoFiltro">Estado</label>
                <select
                  id="estadoFiltro"
                  className="form-control form-control-sm"
                  value={estadoFiltro}
                  onChange={(e) => {
                    setEstadoFiltro(e.target.value);
                    setPageNumber(0);
                  }}
                >
                  <option value="todos">Todos</option>
                  <option value="activo">Activos</option>
                  <option value="inactivo">Inactivos</option>
                </select>
              </div>

              <button
                type="button"
                className="btn btn-outline-secondary btn-sm mt-3"
                onClick={limpiarFiltros}
              >
                <FontAwesomeIcon icon={faBroom} className="me-2" />
                Limpiar filtros
              </button>
            </div>
          </div>

          <div className="col-xl-9 col-lg-8">
            <div className="card border-0 shadow-sm h-10">
              <div className="card-header bg-white">
                <div className="row g-2 align-items-center">
                  <div className="col-md-8">
                    <h5 className="card-title text-secondary mb-0">Usuarios</h5>
                    <small className="text-muted">
                      {filteredData.length} resultado
                      {filteredData.length === 1 ? '' : 's'}
                    </small>
                  </div>
                  <div className="col-md-4 text-md-end">
                    <button
                      className="btn btn-success btn-sm"
                      onClick={funcionMostrarModalInsertar}
                    >
                      <FontAwesomeIcon icon={faPlus} className="me-1" /> Nuevo
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-end align-items-center gap-2 small mb-3">
                  <label htmlFor="itemsPerPageUsuarios" className="text-secondary mb-0">
                    Mostrar
                  </label>
                  <select
                    id="itemsPerPageUsuarios"
                    className="form-select form-select-sm w-auto"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value={10}>10</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <span className="text-secondary">registros</span>
                </div>
                {mostrarUsuariosComoCards ? (
                  <div
                    className={`usuarios-mobile-list ${
                      mostrarUsuariosDosPorFila
                        ? 'usuarios-mobile-list--two-columns'
                        : ''
                    }`}
                  >
                    {paginatedData.length === 0 ? (
                      <div className="card usuarios-mobile-card">
                        <div className="card-body text-center text-muted py-4">
                          No hay usuarios para los filtros seleccionados.
                        </div>
                      </div>
                    ) : (
                      paginatedData.map((drw) => (
                        <div
                          key={drw.strUsuario}
                          className={`card usuarios-mobile-card ${
                            drw.bolActivo
                              ? 'usuarios-mobile-card--activo'
                              : 'usuarios-mobile-card--inactivo'
                          }`}
                        >
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start gap-2 mb-3 usuarios-mobile-header">
                              <div className="usuarios-mobile-identity">
                                <span className="usuarios-mobile-overline">Cuenta</span>
                                <h6 className="mb-1 usuarios-mobile-title">{drw.strUsuario}</h6>
                                <p className="mb-0 small usuarios-mobile-subtitle">{drw.strNombres}</p>
                              </div>
                              <span
                                className={`badge rounded-pill usuarios-mobile-status ${
                                  drw.bolActivo
                                    ? 'usuarios-mobile-status--activo'
                                    : 'usuarios-mobile-status--inactivo'
                                }`}
                              >
                                {drw.bolActivo ? 'Activo' : 'Inactivo'}
                              </span>
                            </div>

                            <div className="usuarios-mobile-fields small">
                              <div className="usuarios-mobile-field">
                                <span className="usuarios-mobile-label">ID</span>
                                <span className="usuarios-mobile-value">{drw.strUsuario}</span>
                              </div>
                              <div className="usuarios-mobile-field">
                                <span className="usuarios-mobile-label">Usuario</span>
                                <span className="usuarios-mobile-value">{drw.strNombres}</span>
                              </div>
                              <div className="usuarios-mobile-field">
                                <span className="usuarios-mobile-label">Tipo</span>
                                <span className="usuarios-mobile-value">{tiposUsuario[drw.strTipo]}</span>
                              </div>
                            </div>

                            {userTipo === 'admin' && (
                              <div className="d-flex justify-content-end gap-2 mt-3 usuarios-mobile-actions">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm usuarios-mobile-action-btn"
                                  onClick={() => funcionMostrarModalActualizar(drw)}
                                  title="Editar usuario"
                                >
                                  <FontAwesomeIcon icon={faFilePen} className="me-1" />
                                  Editar
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm usuarios-mobile-action-btn"
                                  onClick={() => funcionEliminarUsuario(drw.strUsuario)}
                                  title="Eliminar usuario"
                                >
                                  <FontAwesomeIcon icon={faTrashCan} className="me-1" />
                                  Eliminar
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                ) : (
                  <div className="table-responsive tablescroll d-sm-block usuarios-table-wrapper">
                    <table className="table table-hover table-sm table-bordered">
                      <thead className="table table-light ">
                        <tr>
                          <th className='text-secondary small col-1 ' >ID</th>
                          <th className='text-secondary small ' >Usuario</th>
                          <th className='text-secondary small col-1 text-center' >Tipo</th>
                          <th className='text-secondary small col-1 text-center' >Estado</th>
                          {userTipo === 'admin' && <th className='text-white bg-success small col-1 text-center' >Acciones</th>}
                        </tr>
                      </thead>
                      <tbody className="small align-middle">
                        {paginatedData.length === 0 ? (
                          <tr>
                            <td colSpan="5" className="text-center text-muted py-4">
                              No hay usuarios para los filtros seleccionados.
                            </td>
                          </tr>
                        ) : (
                          paginatedData.map((drw) => (
                            <tr key={drw.strUsuario}>
                              <td className="small">{drw.strUsuario}</td>
                              <td className="small">{drw.strNombres}</td>
                              <td className="small text-center">
                                {tiposUsuario[drw.strTipo]}
                              </td>
                              <td className= {`small text-center ${drw.bolActivo === false ? 'text-danger' : '' }`} >{drw.bolActivo ? 'Activo' : 'Inactivo'}</td>
                              {userTipo === 'admin' &&
                                  <td className='text-center'>
                                    <div className="btn-group" role="group" aria-label="">
                                      <button
                                        className="btn btn-sm"
                                        onClick={() => funcionMostrarModalActualizar(drw)}
                                        title="Editar usuario"
                                      >
                                        <FontAwesomeIcon
                                          icon={faFilePen}
                                          className="text-secondary"
                                        />
                                      </button>
                                      <button
                                        className="btn  btn-sm"
                                        onClick={() =>
                                          funcionEliminarUsuario(drw.strUsuario)
                                        }
                                        title="Eliminar usuario"
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrashCan}
                                          className="text-danger"
                                        />
                                      </button>
                                    </div>
                                  </td>
                              }
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="card-footer bg-white">
                <ResponsivePagination
                  pageCount={pageCount}
                  currentPage={currentPage}
                  onPageChange={handlePageClick}
                  onFirstPage={goToFirstPage}
                  onLastPage={goToLastPage}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <InsertarUsuario
            mostrarModalInsertar={mostrarModalInsertar}
            cerrarModalInsertar={funcionCerrarModalInsertar}
            guardarModalInsertar={funcionGuardarUsuario}
          />
          {drwUsuario && (
            <ActualizarUsuario
              mostrarModalActualizar={mostrarModalActualizar}
              cerrarModalActualizar={funcionCerrarModalActualizar}
              actualizarModal={funcionActualizarUsuario}
              actualizaPassword={funcionActualizarPassword}
              drwUsuario={drwUsuario}
            />
          )}
        </div>
      </main>
       ) : (
        <div className="container ">
            <div className='row mt-5'>
            <FontAwesomeIcon icon={faFaceFrown} beat size="4x" style={{color: "#9aaf98",}} />
            </div>
            <div className='row mt-3 text-center'>
            <p className='text-secondary'>Página no encontrada ...</p>

            </div>          
        </div>
      )}
    <footer>
     <Footer/>
    </footer>
    </div>
  );
}

export default TablaUsuarios;
